import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L, { Icon } from "leaflet";
import { useGeolocalizacaoService } from "../../../../../../../use-cases/geo-veles";
import { getZoomLevel } from "../../../../../../../utils";
import { theme } from "../../../../../../styles";
import markerIcon from "../../../../../../../assets/img/marker-icon.png";
import { useAppSelector } from "../../../../../../hooks/store-hooks";

const circleRef = { current: null as any };
const markerRef = { current: null as any };

interface ResetCenterViewProps {
  latLon: [number, number] | null;
}

export const ResetCenterView = ({ latLon }: ResetCenterViewProps) => {

 const { geolocalizacao } = useAppSelector((state) => state);

  const map = useMap();
  const isInitialMount = useRef(true);
  const {
    
    setGeolocalizacaoRadius,
    getGeolocalizacaoByLatLon,
  } = useGeolocalizacaoService();

  // Configuração dos controles do mapa e idioma
  useEffect(() => {
    map.pm.setLang("pt_br", {
      actions: {
        finish: "Salvar alterações",
        cancel: "Cancelar",
      },
      buttonTitles: {
        editButton: "Editar",
      },
      measurements: {
        area: "Área",
        coordinates: "Coordenadas",
        height: "Altura",
        perimeter: "Perímetro",
        radius: "Raio",
        width: "Comprimento",
      },
    });

    map.pm.addControls({
      position: "topright",
      drawCircleMarker: false,
      rotateMode: false,
      customControls: true,
      cutPolygon: false,
      dragMode: false,
      drawCircle: false,
      drawControls: false,
      drawMarker: false,
      drawPolygon: false,
      drawPolyline: false,
      drawRectangle: false,
      drawText: false,
      removalMode: false,
      snappingOption: false,
      editControls: true,
      editMode: true,
    });

    map.pm.setGlobalOptions({
      snappable: false,
      markerEditable: false,
      minRadiusCircle: 1000,
      resizableCircle: true,
      pathOptions: {
        color: theme.palette.primary.main,
      },
      allowSelfIntersection: false,
    });

    map.pm.disableDraw("Polygon");
    map.pm.disableGlobalEditMode();
  }, [map]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (!latLon || !geolocalizacao.selectedGeolocalizacao) return;

    if (circleRef.current) {
      circleRef.current.remove();
    }

    if (markerRef.current) {
      markerRef.current.remove();
    }

    const circle = L.circle(latLon, {
      pmIgnore: false,
      radius: geolocalizacao.radius,
      color: theme.palette.primary.main,
    }).addTo(map);
    circleRef.current = circle;

    const marker = L.marker(latLon, {
      pmIgnore: false,
      icon: new Icon({
        iconUrl: markerIcon,
        iconSize: [40, 40],
        iconAnchor: [20, 40],
      }),
      draggable: false,
    }).addTo(map);
    markerRef.current = marker;

    circle.on("click", (e) => {
      const radiusKm = Math.round(e.target._mRadius / 1000);
      circle
        .bindPopup(
          `<h2><strong>Raio:</strong> ${radiusKm.toLocaleString("pt-BR")} km </h2>`
        )
        .openPopup();
    });

    circle.on("pm:disable", (e: any) => {
      const km = Math.round(e.target._mRadius / 1000);
      const radius = km > 0 ? km * 1000 : 1000;
      circle.setRadius(radius);
      setGeolocalizacaoRadius({ radius });
    });

    marker.on("pm:disable", (e: any) => {
      getGeolocalizacaoByLatLon({
        lat: e.layer._latlng.lat,
        lon: e.layer._latlng.lng,
      });
    });

    map.flyTo(
      [
        geolocalizacao.selectedGeolocalizacao.lat,
        geolocalizacao.selectedGeolocalizacao.lon,
      ],
      getZoomLevel(geolocalizacao.radius),
      { duration: 2 }
    );
  }, [latLon, map]);

  return null;
};
